export class UpdateProduct {
  static readonly type = '[Contract.Product] Update Product';
  constructor(public product: any, public forceCalc: boolean = false) {}
}

export class DeleteProduct {
  static readonly type = '[Contract.Product] Delete Product';
  constructor(public costID: number) {}
}

export class RestoreProduct {
  static readonly type = '[Contract.Product] Restore Product';
  constructor(public costID: number) {}
}

export class SelectAvailableProduct {
  static readonly type = '[Contract.Product] Select Available Product';
  constructor(public costID: number) {}
}

export class RemoveSharedProduct {
  static readonly type = '[Contract.Product] Remove Shared Product';
  constructor(public costID: number) {}
}

export class SyncSharedProducts {
  static readonly type = '[Contract.Product] Sync Shared Products';
  constructor(public costID: number, public modifiedFields: any) {}
}

export class SetProductAutoDisplay {
  static readonly type = '[Contract.Product] Set Product Auto Display';
  constructor(public product: any, public autoDisplayData: any) {}
}

export class AddProductEntities {
  static readonly type = '[Contract.Product] Add Product Entities';
  constructor(public productEntities: any, public forceCalc: boolean = false) {}
}

export class UpdateProductTotals {
  static readonly type = '[Contract.Product] Update Product Totals';
  constructor() {}
}
